// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-context-menu mp-drop-menu{margin-bottom:0;position:absolute;z-index:7000}.mp-context-menu mp-drop-menu mp-items-menu{max-height:340px;min-width:160px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
